@if (isEnabled) {
    <button (click)="analyze()" class="ai-button rainbow">
        <div class="button-text flex flex-row items-center gap-2">
            <i class="fa fa-stars"></i>
            @if (style === 'full') {
                <span>
                    {{ 'translate_analyze' | translate }}
                </span>
            }
        </div>
    </button>
}
